module.exports = __webpack_public_path__ + "static/media/prevoir.40b22133.png";